export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13285.173d9d59.jpg";